import {
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  useTheme,
} from '@material-ui/core';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import CreateIcon from '@material-ui/icons/Create';
import DashboardIcon from '@material-ui/icons/Dashboard';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useThemeType } from '../../contexts/ThemeTypeContext';
import { mainishStyles } from '../../styling';

const MainDrawer = () => {
  let history = useHistory();
  const classes = mainishStyles();
  const theme = useTheme();
  const themeHelper = useThemeType();

  return (
    <Drawer
      variant="persistent"
      anchor={theme.direction === 'rtl' ? 'right' : 'left'}
      open={themeHelper.drawerState}
      classes={{
        paper: classes.drawerPaper,
      }}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <div className={classes.drawerHeader}>
        <IconButton onClick={themeHelper.toggleDrawer}>
          {theme.direction === 'ltr' ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </div>
      <Divider />
      <List>
        <ListItem
          button
          key="Dashboard"
          onClick={() => {
            history.push('/');
          }}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem
          button
          key="Tiket Baru"
          onClick={() => {
            history.push('/layanan');
          }}
        >
          <ListItemIcon>
            <CreateIcon />
          </ListItemIcon>
          <ListItemText primary="Tiket Baru" />
        </ListItem>
        <ListItem
          button
          key="Cek Status"
          onClick={() => {
            history.push('/login');
          }}
        >
          <ListItemIcon>
            <ConfirmationNumberIcon />
          </ListItemIcon>
          <ListItemText primary="Cek Status" />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem
          button
          key="Tema Gelap/Terang"
          onClick={themeHelper.switchThemeType}
        >
          <ListItemIcon>
            <Brightness4Icon />
          </ListItemIcon>
          <ListItemText primary="Tema Gelap" />

          <Switch
            checked={themeHelper.themeType === 'dark' ? true : false}
            onChange={themeHelper.switchThemeType}
            name="Tema Gelap"
          />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default MainDrawer;
